module.exports = __webpack_public_path__ + "static/media/bg-triangle.1fd44bdf.svg";